import React, {Fragment, useRef} from 'react';
import {Form, Field} from 'react-final-form';
import {Popup, Text, Select, Explanation_text} from '../../../components';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import DeleteIcon from '@material-ui/icons/Delete';
import Button from '@material-ui/core/Button';
import { FieldArray } from 'react-final-form-arrays';
import arrayMutators from 'final-form-arrays';
import Checkbox from '@material-ui/core/Checkbox';


export default function Custom_field_popup(props){

  function onSubmit(params){
    props.updateWorkspaceDecisions(params);
  }

  let initial_values=[]; if(props.workspace!=undefined){for(let wd of props.workspace.workspace_decisions){initial_values.push({id:wd.id, name:wd.name, block:wd.block, active:wd.active})}}

  return(
    <Form
      onSubmit={onSubmit}
      initialValues={{workspace_decisions:initial_values}}
      mutators={{
        ...arrayMutators
      }}
    >
      {form_props => (
        <form onSubmit={form_props.handleSubmit}>
        <Popup handleClose={props.handleClose} always_open accept_button='Save' accept_button_click={()=>{form_props.form.submit(); form_props.form.reset(); props.handleClose()}} force_title title={<Field name='workspace_decisions'>{(f)=>{return(<div><Explanation_text inline text='workspace_custom_decisions_title'/>{' ('+((f.input.value=='')?0:f.input.value.length)+'/'+props.max_fields+')'}</div>)}}</Field>} content={
          <div style={{width:'95vw', maxWidth:'600px'}}>
          <FieldArray name='workspace_decisions'>
          {({ fields }) =>
          <div style={{width:'95vw', maxWidth:'600px'}}>
            <Grid container style={{width:'calc(100% - 40px)', marginLeft:'20px', marginTop:'20px'}}>
              <Grid item xs={7}><div style={{width:'calc(100% - 20px)', marginLeft:'10px'}}><Explanation_text color='primary' text='workspace_custom_decision_setup_name_label'/></div></Grid>
              <Grid item xs={2}><div style={{width:'calc(100% - 20px)', marginLeft:'10px'}}><Explanation_text color='primary' text='workspace_custom_decision_setup_block_label'/></div></Grid>
              <Grid item xs={2}><div style={{width:'calc(100% - 20px)', marginLeft:'10px'}}><Explanation_text color='primary' text='workspace_custom_decision_setup_active_label'/></div></Grid>
            </Grid>
            {fields.map((name, index) => (
              <Grid container style={{width:'calc(100% - 40px)', marginLeft:'20px'}}>
                <Grid item xs={7}><div style={{width:'100%', marginTop:'10px', maxWidth:'200px'}}><Text variant='not_outlined' color='transparent' name={`${name}.name`}/></div></Grid>
                <Grid item xs={2}><div style={{marginTop:'15px'}}><Field name={`${name}.block`}>{(f)=><Checkbox checked={(f.input.value==true)?false:true} onChange={(e)=>{f.input.onChange((e.target.checked==true)?false:true)}} name="block" color="primary"/>}</Field></div></Grid>
                <Grid item xs={2}><div style={{marginTop:'15px'}}><Field name={`${name}.active`}>{(f)=><Checkbox checked={f.input.value} onChange={f.input.onChange} name="block" color="primary"/>}</Field></div></Grid>
                <Grid item xs={1} style={{display:'flex', justifyContent:'center', alignItems:'center'}}>{(fields.value[index].id!=undefined)?null:<DeleteIcon style={{marginTop:'15px', cursor:'pointer'}} color='secondary' onClick={()=>{fields.remove(index);}}/>}</Grid>
              </Grid>
          ))}
          <div style={{width:'100%', display:'flex', justifyContent:'center', alignItems:'center', marginTop:'20px', marginBottom:'20px'}}>{(fields.length==props.max_fields)?null:<Button type="button" variant='outlined' color='secondary' onClick={() => {fields.push({active:false, block:false}, undefined)}} style={{marginRight:'10px'}}>Add decision</Button>}</div>
          </div>
          }
          </FieldArray>
          </div>
        }/>
        </form>
      )}
    </Form>
  )
}
